import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

import type { StepperContextValue } from "@/context";
import { loginService } from "@/services/login";
import type { ApiEnvelope } from "@/types/api";

export interface RegisterData {
  firmName?: string;
  nameSurname?: string;
  email?: string;
  phone?: string | number;
  [key: string]: unknown;
}

interface RegisterStore {
  data: RegisterData;
  error: unknown;
  register: (
    registerData: RegisterData,
    stepper: Pick<StepperContextValue, "moveNext">
  ) => Promise<void>;
}

interface LogOutStore {
  data: unknown;
  error: unknown;
  logout: () => Promise<unknown | null>;
}

interface WarmUpStore {
  warm: unknown;
  error: unknown;
  warmup: () => Promise<unknown | null>;
}

export const useRegisterStoreStore = create<RegisterStore>()(
  immer((set) => ({
    data: {},
    error: null,
    register: async (registerData, stepper) => {
      set({ data: {}, error: null });

      try {
        const { data } = await loginService.register<ApiEnvelope<unknown>>(registerData);

        if (data?.header?.isSuccess) {
          stepper.moveNext();
          set({
            data: {
              ...registerData,
            },
          });
        } else {
          set({ error: data.body });
        }
      } catch {
        set({ error: true });
      }
    },
  }))
);

export const useLogOutStore = create<LogOutStore>()(
  immer((set) => ({
    data: null,
    error: null,
    logout: async () => {
      try {
        const response = await loginService.logout();
        set({ data: response, error: null });

        return response;
      } catch {
        set({ error: true });

        return null;
      }
    },
  }))
);

export const useWarmUpStore = create<WarmUpStore>()(
  immer((set) => ({
    warm: null,
    error: null,
    warmup: async () => {
      try {
        const response = await loginService.warmup();
        set({ warm: response, error: null });

        return response;
      } catch {
        set({ error: true });

        return null;
      }
    },
  }))
);
